import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CountryService } from 'src/app/country.service';

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.css']
})
export class HowItWorksComponent implements OnInit {
  @Input('isMobile')
  isMobile = false;
  country = 'sg';
  constructor(private cs: CountryService, private router:Router) { }

  ngOnInit(): void {
    this.country = this.cs.getCountry();
  }

  redirectToRegistration() {
    this.cs.redirectToRegistrationPage();
  }

  redirectToQuickTransfer() {
    this.router.navigate(['/country-details']);
  }
}
